import 'babel-polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';

import VTooltip from 'v-tooltip';
import axios from 'axios';
import Moment from 'moment';
import colors from 'vuetify/es5/util/colors';
import App from './App.vue';

import router from './router';
import store from './store/index';
import 'vuetify/dist/vuetify.min.css';
import './ui/_styles/application.scss';
import auth from './services/auth';

import {
  Debugger,
} from './utils/index';

Vue.config.productionTip = false;
Vue.prototype.$debugger = Debugger;
Vue.prototype.$moment = Moment;

axios.interceptors.request.use(auth.requestInterceptor);
axios.interceptors.response.use(x => x, auth.responseErrorInterceptor);

Vue.use(VTooltip);

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: colors.blue.accent3,
    secondary: colors.blue.lighten1,
    accent: colors.shades.white,
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
